import { Button } from "flowbite-react";
import {
  maskChassi,
  maskCNPJ,
  maskCPF,
  maskLicensePlate,
} from "../../utils/masks";
import { CgSpinner } from "react-icons/cg";
import { FaCheck, FaSearch } from "react-icons/fa";
import StateSelectInput from "./StateSelectInput";
import {
  fieldControlBase,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const QueryVehicleInput = ({
  info,
  setInfo,
  isLoading,
  error,
  type = "PLACA",
  hasState = false,
  setState,
  stateValue,
}) => {
  const handleChange = (event) => {
    let valor = event.target.value;

    if (type === "PLACA") {
      valor = maskLicensePlate(valor);
    } else if (type === "CHASSI") {
      valor = maskChassi(valor);
    } else if (type === "CPF/CNPJ") {
      const numericValue = valor.replace(/\D/g, "");
      valor = numericValue.length <= 11 ? maskCPF(valor) : maskCNPJ(valor);
    } else {
      if (valor?.length <= 7) {
        valor = maskLicensePlate(valor);
      } else {
        valor = maskChassi(valor);
      }
    }

    setInfo(valor);
  };

  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
      <div className="flex items-end gap-2 flex-col md:flex-row">
        <div className="relative w-full md:w-auto md:min-w-[230px]">
          <label htmlFor="info" className={fieldLabel}>
            {type?.replace("/ESTADO", "")}
          </label>

          <input
            id="info"
            type="text"
            className={`${fieldControlBase} text-sm pr-10`}
            placeholder="Digite os dados da consulta"
            value={info}
            maxLength={type === "PLACA" ? 8 : type === "CPF/CNPJ" ? 18 : 18}
            onChange={handleChange}
            required
          />
          {((type === "CPF/CNPJ" && (info.length === 14 || info.length === 18)) ||
            info.length === 7 ||
            info.length === 17) && (
            <FaCheck className="absolute right-3 top-[39px] text-emerald-500" />
          )}
        </div>

        {hasState ||
          ((type === "PLACA/ESTADO" || type === "PLACA/CHASSI/ESTADO") && (
            <div className="w-full md:w-[120px]">
              <StateSelectInput
                className="w-full"
                stateValue={stateValue}
                setState={setState}
              />
            </div>
          ))}

        <Button
          className="h-[42px] w-full md:w-auto rounded-xl bg-emerald-600 px-4 text-white shadow-sm transition hover:bg-emerald-700 flex items-center justify-center"
          type="submit"
          isProcessing={isLoading}
          processingSpinner={<CgSpinner className="h-5 w-5 animate-spin" />}
          disabled={
            (type === "CPF/CNPJ"
              ? !(info.length === 14 || info.length === 18)
              : !(info.length === 7 || info.length === 17)) ||
            (hasState && stateValue === "")
          }
        >
          <div className="flex items-center gap-2">
            <FaSearch />
            <span>{isLoading ? "Consultando..." : "Consultar"}</span>
          </div>
        </Button>
      </div>

      {error && <small className={fieldErrorText}>{type} inválido!</small>}
    </div>
  );
};

export default QueryVehicleInput;
